/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Minicalendar (not minical widget, but minicalendar embeds in our view) related javascript

namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  // Render a javascript-based minicalendar
  //
  // By default, this only renders the calendar rows themselves, and not any
  // header or footer.  Each date will be linked to linkTemplate.
  //
  // Looks for various data-minicalendar attributes inside container for the various
  // functions:
  //   "true" => container
  //   "previous" => previous month link
  //   "next" => next month link
  //   "month-label" => label for currently displayed month
  //   "calendar" => container for calendar rows
  //
  // Options can be set with various data attributes on the container:
  //   data-minicalendar-initial => start date (YYYY-MM-DD)
  //   data-minicalendar-today => today's date (YYYY-MM-DD)
  //   data-minicalendar-render-initial => render the initial calendar (defaults to off)
  //   data-minicalendar-start-day => start day of week (0=sunday, 1=monday, etc.)
  //   data-minicalendar-link-template => URL template for each day's link, with @YEAR@ @MONTH@ @DAY@ placeholders
  //   data-minicalendar-class-prefix => prefix to add to all class names
  //   data-minicalendar-class-ITEM => various css classes
  //     ITEM can be: disabled, selected, active, past, today
  //   data-minicalendar-tag-week => tag name for week rows (default: TR)
  //   data-minicalendar-tag-day => tag name for day cell (default: TD)
  //   data-minicalendar-format-month => format for current month label
  //   data-minicalendar-format-day => format for date cell
  const Cls = (exports.MiniCalendar = class MiniCalendar {
    static initClass() {
      this.prototype.default_options = {
        // Outer container
        container: undefined,
        
        // initial date
        initial: undefined,
  
        // today's date
        today: new Date(),
  
        // selected date
        selected: undefined,
  
        // Render initial calendar
        renderInitial: false,
  
        // template for each day's link URL, should have @YEAR@ @MONTH@ @DAY@ placeholders
        linkTemplate: '/calendar/@YEAR@/@MONTH@/@DAY@',
  
        // Start day of week (0=sunday, 1=monday, etc.)
        startDay: 0,
  
        // Limit viewable range (months in either direction from today)
        dateLimit: 24,
  
        // CSS class names
        classPrefix: '',
        disabledClass: 'disabled',
        selectedClass: 'selected',
        activeClass: 'active',
        pastClass: 'dimday', // days outside this month
        todayClass: 'today',
  
        // tag names
        tagWeek: 'tr',
        tagDay: 'td',
  
        // formats
        formatMonth: 'MMMM',
        formatMonthYear: 'MMMM yyyy',
        formatDay: 'd'
      };
    }

    // Initialize this instance. options specified override those found on the element
    constructor(element, options) {
      this.changeMonth = this.changeMonth.bind(this);
      this._attachEvents = this._attachEvents.bind(this);
      this._render = this._render.bind(this);
      this._updateNavLabels = this._updateNavLabels.bind(this);
      this._parseOptions = this._parseOptions.bind(this);
      if (options == null) { options = {}; }
      this.element = $(element);

      this.options = $.extend({}, this.default_options, this._parseOptions(), options);
      if (!this.options.initial) { this.options.initial = this.options.today; }
      if (!this.options.selected) { this.options.selected = this.options.today; }

      // set dates
      if (typeof(this.options.today) !== 'object') { this.options.today = new Date(this.options.today); }
      if (typeof(this.options.initial) !== 'object') { this.options.initial = new Date(this.options.initial); }
      if (typeof(this.options.selected) !== 'object') { this.options.selected = new Date(this.options.selected); }

      this.currentDate = new Date(this.options.initial);
      this.minimumDate = this.currentDate.clone().add({months: -this.options.dateLimit});
      this.maximumDate = this.currentDate.clone().add({months: this.options.dateLimit});

      this._updateNavLabels();
      this._attachEvents();
    }

    // Change the currently displayed month (change is how many months to change forward or back)
    changeMonth(change) {
      this.currentDate.addMonths(change);
      this._render();
      return false;
    }

    _attachEvents() {
      this.element.on('click', '[data-minicalendar="next"]', evt => {
        if (!$(evt.target).hasClass('disabled')) { this.changeMonth(1); }
        return evt.preventDefault();
      });
        
      return this.element.on('click', '[data-minicalendar="previous"]', evt => {
        if (!$(evt.target).hasClass('disabled')) { this.changeMonth(-1); }
        return evt.preventDefault();
      });
    }

    // Rerender the calendar
    _render() {
      const calendar_html = [];

      // get first and last dates of this month...
      let first = this.currentDate.clone().set({day: 1});
      const last = first.clone().add({months: 1}).add({days: -1});

      // ...and adjust them to stretch to a full week
      const dow = first.getDay();
      first = first.add({days: -dow});
      last.add({days: 6 - last.getDay()});

      // Loop over and do the work
      const current = first.clone();
      while (!current.isAfter(last)) {
        // Week begin
        if (current.getDay() === 0) { calendar_html.push(`<${this.options.tagWeek}>`); }

        // The space here keeps datejs from evaluating "d" as a shortcut for m/d/Y
        const label = current.toString(` ${  this.options.formatDay}`);

        // Build link
        let url = this.options.linkTemplate.replace(/@YEAR@/, current.getFullYear());
        url = url.replace(/@DAY@/, current.getDate());
        url = url.replace(/@MONTH@/, current.getMonth() + 1);

        const content = `<a href=\"${url}\">${label}</a>`;

        const classes = [];
        if (current.getMonth() !== this.currentDate.getMonth()) { classes.push(this.options.pastClass); }
        // classes.push "#{@options.classPrefix}#{@options.activeClass}" if current.getMonth() != first.getMonth()
        if (current.equals(this.options.today)) { classes.push(this.options.todayClass); }
        if (current.equals(this.options.selected)) { classes.push(this.options.selectedClass); }

        calendar_html.push(`<${this.options.tagDay} class=\"${classes.join(' ')}\">${content}</${this.options.tagDay}>`);
        
        // week end
        if (current.getDay() === 6) { calendar_html.push(`</${this.options.tagWeek}>`); }

        current.add({days: 1});
      }

      // Update DOM
      const month_label = this.currentDate.getFullYear() !== this.options.today.getFullYear() ?
        this.currentDate.toString(this.options.formatMonthYear)
      :
        this.currentDate.toString(this.options.formatMonth);

      this.element.find('[data-minicalendar="month-label"]').html(month_label);
      this.element.find('[data-minicalendar="calendar"]').html(calendar_html.join(''));

      // And the enabled state of the nav buttons, as well as accessibility labels
      this._updateNavLabels();

      this.element.find('[data-minicalendar="previous"]')
        .toggleClass('disabled', !this.currentDate.isAfter(this.minimumDate));
      return this.element.find('[data-minicalendar="next"]')
        .toggleClass('disabled', !this.currentDate.isBefore(this.maximumDate));
    }

    // Update minicalendar navigation accessibility labels
    _updateNavLabels() {
      const previous_month = this.currentDate.clone().add({months: -1});
      const next_month = this.currentDate.clone().add({months: 1});
      this.element.find('[data-minicalendar="previous"]')
        .find('.sr-only').html(`Switch to ${previous_month.toString("MMMM yyyy")}`);
      return this.element.find('[data-minicalendar="next"]')
        .find('.sr-only').html(`Switch to ${next_month.toString("MMMM yyyy")}`);
    }


    // Parse options from data attributes
    _parseOptions() {
      const data = this.element.data();
      const options = {};

      // attributes
      for (const item of [
        ['initial',         'Initial'],
        ['today',           'Today'],
        ['renderInitial',   'RenderInitial'],
        ['startDay',        'StartDay'],
        ['linkTemplate',    'LinkTemplate'],
        ['tagWeek',         'TagWeek'],
        ['tagDay',          'TagDay'],
        ['formatMonth',     'FormatMonth'],
        ['formatMonthYear', 'FormatMonthYear'],
        ['formatDay',       'FormatDay']
      ]) {
        const option_name = item[0];
        const data_name = item[1];
        if (data[`minicalendar${data_name}`] != null) { options[option_name] = data[`minicalendar${data_name}`]; }
      }

      // classes
      const iterable = ['Prefix', 'Disabled', 'Selected', 'Active', 'Past', 'Today'];
      for (let i = 0; i < iterable.length; i++) {
        const name = iterable[i];
        if (data[`minicalendarClass${name}`]) { options[`class${name}`] = data[`minicalendarClass${name}`]; }
      }

      return options;
    }
  });
  Cls.initClass();

  // Activate any minicalendars in page on ready
  return $(() => $('[data-minicalendar="true"]').each(function() {
    return new exports.MiniCalendar(this);
  }));
});
